export const telephone = '01 47 18 33 33';
